import React from 'react';

interface Props {
  prevLabel?: string;
  nextLabel?: string;
  onPrev?: () => void;
  onNext?: () => void;
  disablePrev?: boolean;
  disableNext?: boolean;
}

export default function LearningFooterNav({
                                            prevLabel = 'Previous',
                                            nextLabel = 'Next',
                                            onPrev,
                                            onNext,
                                            disablePrev,
                                            disableNext,
                                          }: Props) {
  return (
    <div className="learning-footer-nav">
      <button
        type="button"
        className="learning-nav-btn"
        onClick={onPrev}
        disabled={disablePrev}
        aria-label={prevLabel}
      >
        <span aria-hidden="true">‹</span>
        <span>{prevLabel}</span>
      </button>

      <button
        type="button"
        className="learning-nav-btn"
        onClick={onNext}
        disabled={disableNext}
        aria-label={nextLabel}
      >
        <span>{nextLabel}</span>
        <span aria-hidden="true">›</span>
      </button>

      <style>{`
        .learning-footer-nav {
          display: flex;
          justify-content: space-between;
          gap: 1rem;
          padding: 1rem 1.25rem;
          border-top: 1px solid #e5e7eb;
          background: #fff;
          position: sticky;
          bottom: 0;
        }

        .learning-nav-btn {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          padding: 0.75rem 1rem;
          border-radius: 10px;
          border: 1px solid rgba(0,0,0,0.12);
          background: #0a66ff;
          color: #fff;
          cursor: pointer;
          font-size: 0.95rem;
          font-weight: 600;
        }

        .learning-nav-btn:hover:not(:disabled) {
          background: #004fe0;
        }

        .learning-nav-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      `}</style>
    </div>
  );
}